import React, { useEffect, useState } from "react";
import { AnimationOnScroll } from "react-animation-on-scroll";
import "./MediaPresence.scss";
import Title from "../Title/Title";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

const MediaPresence = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mediaNews, setMediaNews] = useState([]);
  const [modalContent, setModalContent] = useState({
    title: "",
    image: "",
    logo: "",
  });

  useEffect(() => {
    const fetchMedia = async () => {
      try {
        const response = await fetch(
          "https://admin.wisefinserv.com/api/wisefunds/media"
        );
        const data = await response.json();
        setMediaNews(data);
      } catch (error) {
        console.error("Error fetching media:", error);
      }
    };

    fetchMedia();
  }, []);

  const responsive = {
    600: { items: 2 },
    1200: { items: 5 },
    1500: { items: 5 },
  };

  const handleModalOpen = (title, image, logo) => {
    setModalContent({ title, image, logo });
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // IMPORTANT: clone before reverse
  const items = [...mediaNews.reverse()]
    .reverse()
    .map((item, index) => (
      <div
        key={index}
        className="reviews-right-card"
        style={{ cursor: "pointer" }}
        onClick={() => {
          if (item.type === "link" && item.link) {
            window.open(item.link, "_blank", "noopener,noreferrer");
          } else if (item.type === "model") {
            handleModalOpen(
              item.title,
              item.image?.url,
              item.logo?.url
            );
          }
        }}
      >
        {item.logo?.url && (
          <img
            src={item.logo.url}
            alt="Logo"
            className="modal-logo"
            style={{ width: "80px", marginBottom: "10px" }}
          />
        )}

        <h4>{item.title}</h4>

        <div className="box-paragraph">
          <p>{item.media}</p>
          <span>{item.date}</span>
        </div>
      </div>
    ));

  return (
    <>
      <Title title1="Our" title2="Media" title3="Presence" />

      <div className="reviews">
        <div className="reviews-right">
          <AnimationOnScroll
            offset={0}
            animateOnce={true}
            animateIn="animate__slideInUp"
          >
            <AliceCarousel
              mouseTracking
              items={items}
              responsive={responsive}
              controlsStrategy="alternate"
              autoPlay={true}
              infinite={true}
              autoPlayInterval={1500}
              disableDotsControls={true}
              renderPrevButton={() => (
                <button className="carousel-btn prev">‹</button>
              )}
              renderNextButton={() => (
                <button className="carousel-btn next">›</button>
              )}
            />
          </AnimationOnScroll>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="modal-close" onClick={handleCloseModal}>
              ✕
            </button>

            {modalContent.logo && (
              <img
                src={modalContent.logo}
                alt="Logo"
                className="modal-logo"
                style={{ width: "80px", marginBottom: "10px" }}
              />
            )}

            <h2>{modalContent.title}</h2>

            {modalContent.image && (
              <img
                src={modalContent.image}
                alt={modalContent.title}
                className="modal-image"
                style={{ maxWidth: "100%", marginTop: "10px" }}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default MediaPresence;